/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');
		this.next = null;
		this.previous = null;
		this.slider = null;
	}

	/**
	 * Fetches the product recommendations from Shopify
	 * @async
	 * @function fetchProducts
	 * @returns {void}
	 */
	async fetchProducts() {
		try {
			const response = await fetch(this.dataset.url);
			const text = await response.text();

			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector('product-recommendations');

			if (recommendations && recommendations.innerHTML.trim().length) {
				this.innerHTML = recommendations.innerHTML;

				if ( this.parent ) {
					this.parent.classList.add('product-recommendations--full');

					if ( document.body.classList.contains('open-cart')) {
						this.parent.classList.add('active');
					}
				}

			}
			this.classList.add('product-recommendations--loaded');
			this.next = this.querySelector('#recommendations-next');
			this.previous = this.querySelector('#recommendations-previous');
			this.slider = this.querySelector('.cart-drawer--recommendations--products');
		} catch (error) {
			console.error(error);
		}
	}

	/**
	 * Handles the next and previous button clicks
	 * @function handleClick
	 * @param {string} direction - next or previous
	 * @returns {void}
	 */
	handleClick(direction) {
		const width = this.slider.offsetWidth;
		const scrollAmount = direction === 'next' ? width : -width;

		this.slider.scrollBy(scrollAmount, 0);
	}

	/**
	 * Sets the visibility of the next and previous buttons
	 * @function onScroll
	 * @returns {void}
	 */
	onScroll() {
		const width = this.slider.offsetWidth;
		const scrollLeft = this.slider.scrollLeft;
		const scrollRight = scrollLeft + width;

		if (scrollLeft === 0) {
			this.previous.classList.add('hidden');
		} else {
			this.previous.classList.remove('hidden');
		}

		if (scrollRight === this.slider.scrollWidth) {
			this.next.classList.add('hidden');
		} else {
			this.next.classList.remove('hidden');
		}
	}

	async connectedCallback() {
		await this.fetchProducts();

		if (this.next && this.previous && this.slider) {
			// Call this here to make the previous button hidden on initial render
			this.onScroll();
			this.next.addEventListener('click', () => this.handleClick('next'));
			this.previous.addEventListener('click', () => this.handleClick('previous'));
			this.slider.addEventListener('scroll', () => this.onScroll());
		}

	}
}

customElements.define('product-recommendations', ProductRecommendations);
